/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const challengeByTypeSampleSchema = z.object({
  id: z.number(),
  slug: z.string(),
  title: z.string(),
  cefrLevel: z.string(),
  definition: z.string(),
  definitionSimple: z.string().nullable(),
  partOfSpeech: z.string(),
});

export type IChallengeByTypeSample = z.infer<typeof challengeByTypeSampleSchema>;

export const getPublicChallengesByTypeV1ResponseDataSchema = z.object({
  totalCount: z.number(),
  samples: z.array(challengeByTypeSampleSchema),
});

export type IGetPublicChallengesByTypeV1ResponseData = z.infer<
  typeof getPublicChallengesByTypeV1ResponseDataSchema
>;

export const getPublicChallengesByTypeV1ResponseSchema = createApiResponseSchema(
  getPublicChallengesByTypeV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetPublicChallengesByTypeV1ResponseData>>;

export type IGetPublicChallengesByTypeV1Response = IAPI<IGetPublicChallengesByTypeV1ResponseData>;
